import ExtensibilityContext from 'owa-service/lib/contract/ExtensibilityContext';
import { getExtensibilityContext } from 'owa-addins-store';
import { parseConsentStateInfo } from '../util/InClientStoreHelper';
import ServiceEndpoint = OSF.ServiceEndpoint;

export function registerMethod(serviceEndPoint: ServiceEndpoint) {
    serviceEndPoint.registerMethod(
        'GetAllInstalledAddIns',
        (data: any, responseMethod: Function) => {
            const context = getExtensibilityContext() as ExtensibilityContext;
            let extensions = [];
            context.Extensions.forEach(ext => {
                if (!(ext.TypeString === 'Private' || ext.TypeString === 'Default')) {
                    extensions.push([
                        ext.Id,
                        ext.MarketplaceAssetID,
                        ext.Enabled.toString(),
                        parseConsentStateInfo(ext.ConsentState),
                        ext.TypeString,
                        ext.LicenseStatus.toString(),
                        ext.TrialExpirationDate,
                        ext.IsMandatory.toString(),
                        ext.OriginString,
                    ]);
                }
            });
            responseMethod(extensions, 0);
        },
        Microsoft.Office.Common.InvokeType.async,
        false /* isBlocking */
    );
}
